import getAllAccessRight from "./getAllAccessRight.api";
import getAllRoleList from "./getAllRoleList.api";
import roleAccessRight from "./roleAccessRight.api";
import fetchAccessRightStructure from "./fetchAccessRightStructure.api";
import userRole from "./userRole.api";

const roleAccessRightApi = {
  getAllAccessRight,
  getAllRoleList,
  roleAccessRight,
  fetchAccessRightStructure,
  userRole
};

export default roleAccessRightApi;
